import { FC, useState } from 'react';

import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Scope } from '@unform/core';
import CheckBox from 'src/components/Form/Checkbox';
import DatePicker from 'src/components/Form/DatePicker';
import Select from 'src/components/Form/Select';
import { Item } from 'src/components/Form/Select/interfaces';
import TextField from 'src/components/Form/TextField';
import { operators } from 'src/utils/helpers';

const statusItems: Item[] = [
  { key: 0, label: 'Pendente', value: 'pending' },
  { key: 1, label: 'Ativo', value: 'active' },
  { key: 2, label: 'Inativo', value: 'inactive' },
];

const Filters: FC = () => {
  const [birthBetween, setBirthBetween] = useState(false);

  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Scope path="birth_date">
        <Grid item xs={12}>
          <Typography variant="body1">Data de Nascimento</Typography>
        </Grid>
        <Grid item xs={4}>
          <Select
            name="operator"
            label="Operador"
            items={operators}
            onChange={(value: any) => setBirthBetween(value === 'between')}
            variant="outlined"
            fullWidth
            size="small"
          />
        </Grid>

        <Grid item xs={birthBetween ? 4 : 8}>
          <DatePicker
            label={birthBetween ? 'De' : 'Data'}
            name="value"
            fullWidth
            defaultValue={null}
            inputVariant="outlined"
            size="small"
          />
        </Grid>

        {birthBetween && (
          <Grid item xs={4}>
            <DatePicker
              label="Até"
              name="value_end"
              fullWidth
              defaultValue={null}
              inputVariant="outlined"
              size="small"
            />
          </Grid>
        )}
      </Scope>

      <Grid item xs={12}>
        <TextField name="name" label="Nome" size="small" />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          name="document"
          label="CPF"
          size="small"
          mask="cpf"
          returnUnmasked
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          name="phone"
          label="Telefone"
          size="small"
          mask="phoneOrCellphone"
          returnUnmasked
        />
      </Grid>

      <Grid item xs={12}>
        <TextField name="email" label="E-mail" size="small" />
      </Grid>

      <Grid item xs={6}>
        <Select name="status" label="Status" items={statusItems} size="small" />
      </Grid>

      <Grid item xs={6}>
        <Select
          name="origin"
          label="Origem do Cadastro"
          items={[
            { key: 1, label: 'IFBOLSAS', value: 'ifbolsas' },
            { key: 2, label: 'IFEPAF', value: 'ifepaf' },
          ]}
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CheckBox
          name="without_subscription"
          label="Sem Assinatura"
          size="small"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CheckBox
          name="without_collaborator_voucher"
          label="Sem Voucher como Colaborador"
          size="small"
        />
      </Grid>
    </>
  );
};

export default Filters;
